<script setup>
import { inject } from 'vue';
import { CORE_USER_PERMISSIONS as CUP } from '@/enums/CoreUserPermissions.js';

const userCan = inject('userCan');

function canSeeStats() {
  return userCan(CUP.VIEW_ALL_MESSAGES)
    && userCan(CUP.VIEW_ALL_ACCOUNTS)
    && userCan(CUP.VIEW_ALL_COMPANIES)
    && userCan(CUP.VIEW_LOGS)
}
</script>

<template>
  <!-- Sidebar Menu -->
  <nav class="mt-2 nav-flat">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" data-accordion="true" role="menu">
      <li class="nav-item closes-sidebar">
        <router-link :to="{ name: 'home' }" class="nav-link">
          <i class="fas fa-arrow-left nav-icon"></i>
          <p>Torna ad Aziende</p>
        </router-link>
      </li>
      <li class="nav-header text-sm text-truncate" style="text-transform: uppercase; max-width: 238px">
        Gestione
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_COMPANIES)">
        <router-link :to="{path: '/admin/company'}" class="nav-link ">
          <i class="fas fa-building nav-icon"></i>
          <p>Aziende</p>
        </router-link>
      </li>

      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_ACCOUNTS)">
        <router-link to="/admin/account" class="nav-link ">
          <i class="fas fa-inbox nav-icon"></i>
          <p>Account</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_USERS)">
        <router-link to="/admin/user" class="nav-link ">
          <i class="fas fa-user nav-icon"></i>
          <p>Utenti</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_GROUPS)">
        <router-link to="/admin/group" class="nav-link ">
          <i class="fas fa-users nav-icon"></i>
          <p>Gruppi</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_OAUTHAPPS)">
        <router-link to="/admin/oauthapp" class="nav-link ">
          <i class="fas fa-cube nav-icon"></i>
          <p>Applicazioni OAuth</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.MANAGE_RETENTION)">
        <router-link to="/admin/retention" class="nav-link ">
          <i class="fas fa-box nav-icon"></i>
          <p>Conservazione</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="userCan(CUP.VIEW_LOGS)">
        <router-link to="/admin/logs" class="nav-link ">
          <i class="fas fa-history nav-icon"></i>
          <p>Logs</p>
        </router-link>
      </li>
      <li class="nav-item closes-sidebar" v-if="canSeeStats()">
        <router-link to="/admin/stats" class="nav-link ">
          <i class="fas fa-chart-line nav-icon"></i>
          <p>Statistiche</p>
        </router-link>
      </li>
    </ul>
  </nav>
</template>
